import React from 'react';
import Icon from '../Icon/Icon';
import THubBase from './@types/HubBase';
import HubControl from './HubControl';
import HubControlBody from './HubControlBody';
import HubBase from './HubBase';
import { Image } from '../Image';
import { TextBodySmall } from '../Text';
import { resolveFetchPriority } from '../Image/fetchPriority';

const NavHub = ({
  bodyTitle,
  bodyDescription,
  onClick,
  href,
  iconName,
  imageSrc = '',
  imageLoading,
  decoding,
  alt = 'image',
  fetchPriority,
  fetchpriority,
  aspectRatio = 'landscape',
  isParent,
  target,
  ...rest
}: THubBase) => {
  const resolvedFetchPriority = resolveFetchPriority({ fetchPriority, fetchpriority }) ?? 'high';

  return (
    <HubBase {...rest} kind="nav">
      <HubControl onClick={onClick} href={href} target={target}>
        {iconName && <Icon name={iconName} />}
        {imageSrc && (
          <Image
            loading={imageLoading}
            decoding={decoding}
            src={imageSrc}
            alt={alt}
            aspectRatio={aspectRatio}
            fetchPriority={resolvedFetchPriority}
          />
        )}
        <HubControlBody>
          <strong>{bodyTitle}</strong>
          {bodyDescription && <TextBodySmall color="text-secondary">{bodyDescription}</TextBodySmall>}
        </HubControlBody>
        {isParent && <Icon name="arrow-right-regular" />}
      </HubControl>
    </HubBase>
  );
};

export default NavHub;
